import React, { Fragment } from "react";
import BaseComponent, { connect } from "@common/components/base.component";
import { ddados } from "../responderExigencia.ddados";
import autobind from "react-autobind";
import RedeSIMForm from "../../redeSIM.form";
import ResponderExigenciaForm from "../components/responderExigencia.form";
import responderExigenciaSelector from "../store/responderExigencia.selectors";
import responderExigenciaActions from "../store/responderExigencia.actions";


class Container extends BaseComponent {
  constructor(props) {
    super(props);
    autobind(this);
  }

  componentDidMount() {
    this.props.responderExigenciaActions.resetForm();
  }

  verifyCallback(response) {
    this.props.responderExigenciaActions.setTokenRecaptcha(response);
  }

  expiredCallback() {
    this.props.responderExigenciaActions.setTokenRecaptcha("");
  }

  onSubmit(values) {
    this.props.responderExigenciaActions.validaAnaliseExigencia(values);
  }

  render() {
    const { responderExigenciaSelector } = this.props;
    const { responderExigencia } = responderExigenciaSelector;
    const { DataGridExigencia, FormExigencia } = responderExigencia;

    const responderExigenciaForm = DataGridExigencia.length > 0 || FormExigencia?.IdAnalise;

    return (
      <Fragment>
        { responderExigenciaForm && (
          <ResponderExigenciaForm />
        )}

        { !responderExigenciaForm && (
          <RedeSIMForm
            title={ddados.Titulo}
            verifyCallback={this.verifyCallback}
            expiredCallback={this.expiredCallback}
            onSubmit={this.onSubmit}
            isView 
          />
        )}
      </Fragment>
    );
  }
}

export default connect({
  actions: {
    responderExigenciaActions
  },
  selectors: {
    responderExigenciaSelector
  }
})(Container);

